import { Directive, ElementRef } from '@angular/core';
import { Highlightable } from '@angular/cdk/a11y';

@Directive({
  selector: '[dojoSmartLinkOption]',
})
export class SmartLinkOptionDirective implements Highlightable {
  constructor(private readonly elementRef: ElementRef<HTMLElement>) {}

  readonly disabled = false;

  setActiveStyles(): void {
    this.elementRef.nativeElement.classList.add('option-item--highlighted');
    this.elementRef.nativeElement.scrollIntoView({ block: 'nearest' });
  }

  setInactiveStyles(): void {
    this.elementRef.nativeElement.classList.remove('option-item--highlighted');
  }
}
